"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IlCardAssignment = exports.IlAssignmentContentDescription = exports.ilAssignmentFooterSx = exports.ilAssignmentDescriptionSx = exports.truncateSx = void 0;
var il_card_1 = require("../il-card/il-card");
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var enums_1 = require("../../shared/enums");
var icon_1 = require("../icon/icon");
var typeography_common_1 = require("../typeography/typeography.common");
var helpers_1 = require("../../shared/helpers");
var subject_icon_1 = require("../subject-icon/subject-icon");
var providers_1 = require("../../providers");
var brand_config_1 = require("../../configs/brand.config");
exports.truncateSx = {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
};
exports.ilAssignmentDescriptionSx = {
    display: 'flex',
    flex: '0 1',
    flexDirection: 'column',
    alignContent: 'flex-start',
    color: 'text.secondary',
};
exports.ilAssignmentFooterSx = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    flexWrap: 'nowrap',
    mx: '0.75rem',
    mt: '0.3125rem',
    pt: '0.3125rem',
    borderTopStyle: 'solid',
    borderTopWidth: '0.0625rem',
    borderTopColor: 'action.disabledBackground',
};
function IlAssignmentContentDescription(_a) {
    var assignmentType = _a.assignmentType;
    var defaultAssignmentTypeIconProps = {
        size: enums_1.IconSizeEnum.XXSMALL,
        sx: { display: 'flex', alignItems: 'center', '& svg': { fontSize: '0.75em' } },
    };
    var assignmentTypeIconMap = new Map([
        [
            enums_1.AssignmentTypeEnum.PROJECT,
            react_1.default.createElement(icon_1.Icon, __assign({}, defaultAssignmentTypeIconProps, { icon: enums_1.IconEnum.NOTEBOOK,
                dataTestId: 'project' })),
        ],
        [
            enums_1.AssignmentTypeEnum.QUIZ,
            react_1.default.createElement(icon_1.Icon, __assign({}, defaultAssignmentTypeIconProps, { icon: enums_1.IconEnum.CIRCLE_QUESTION,
                dataTestId: 'circle-question' })),
        ],
        [
            enums_1.AssignmentTypeEnum.LESSON,
            react_1.default.createElement(icon_1.Icon, __assign({}, defaultAssignmentTypeIconProps, { icon: enums_1.IconEnum.OUTLINED_OPEN_BOOK,
                dataTestId: 'book-open' })),
        ],
        [
            enums_1.AssignmentTypeEnum.TEST,
            react_1.default.createElement(icon_1.Icon, __assign({}, defaultAssignmentTypeIconProps, { icon: enums_1.IconEnum.STAR,
                dataTestId: 'star' })),
        ],
        [
            enums_1.AssignmentTypeEnum.RESOURCE,
            react_1.default.createElement(icon_1.Icon, __assign({}, defaultAssignmentTypeIconProps, { icon: enums_1.IconEnum.LIGHT_BOOKS,
                dataTestId: 'light-books' })),
        ],
    ]);
    return (react_1.default.createElement(material_1.Box, { sx: { display: 'flex', justifyContent: 'flex-start', alignItems: 'center' } },
        assignmentTypeIconMap.get(assignmentType),
        react_1.default.createElement(typeography_common_1.ILCaption, { textTransform: 'capitalize', sx: __assign({ pl: '0.25rem', color: 'text.secondary', fontSize: '0.75rem' }, exports.truncateSx) }, assignmentType)));
}
exports.IlAssignmentContentDescription = IlAssignmentContentDescription;
function IlCardAssignment(_a) {
    var subject = _a.subject, assignmentTitle = _a.assignmentTitle, assignmentType = _a.assignmentType, assignmentState = _a.assignmentState, courseTitle = _a.courseTitle, unitTitle = _a.unitTitle, dueDate = _a.dueDate, score = _a.score, scoreTotal = _a.scoreTotal, _b = _a.meetsThreshold, meetsThreshold = _b === void 0 ? true : _b, _c = _a.clickable, clickable = _c === void 0 ? true : _c, _d = _a.deactivateCard, deactivateCard = _d === void 0 ? false : _d, dateToday = _a.dateToday, sx = _a.sx, onClick = _a.onClick;
    var dueDateString = (0, helpers_1.formatDueDateString)(dueDate, dateToday);
    var rightPanelIconDefaultSx = {
        width: '0.6875rem',
        height: '0.6875rem',
        padding: 'none',
        '& svg': {
            fontSize: '1em',
        },
    };
    var defaultSubjectIconSxMap = {
        backgroundColor: 'background.paper',
        color: 'action.disabled',
    };
    // Default Values
    var leftPanelIconOverlay = undefined;
    var rightPanelString = '';
    var rightPanelColor = 'text.secondary';
    var rightPanelIcon = undefined;
    var subjectIconSx = { padding: '0.25rem' };
    var assignmentTitleColor = 'text.secondary';
    var rightPanelStatus = undefined;
    switch (assignmentState) {
        case enums_1.AssignmentStateEnum.ACTIVE:
            rightPanelString = dueDateString;
            break;
        case enums_1.AssignmentStateEnum.COMPLETED:
            subjectIconSx = __assign(__assign({}, subjectIconSx), defaultSubjectIconSxMap);
            leftPanelIconOverlay = (react_1.default.createElement(icon_1.Icon, { icon: enums_1.IconEnum.CHECK, size: enums_1.IconSizeEnum.LARGE, sx: {
                    position: 'absolute',
                    top: 2,
                    left: 2,
                    color: 'primary.dark',
                }, dataTestId: "check-icon" }));
            rightPanelColor = '#5FA900';
            rightPanelString = 'Completed';
            if (scoreTotal) {
                rightPanelString = "Score:".concat(score, "/").concat(scoreTotal);
                rightPanelIcon = (react_1.default.createElement(icon_1.Icon, { icon: enums_1.IconEnum.CHECK, sx: rightPanelIconDefaultSx, dataTestId: "meet-threshold-score-icon" }));
                if (!meetsThreshold) {
                    rightPanelColor = 'error.main';
                    rightPanelIcon = (react_1.default.createElement(icon_1.Icon, { icon: enums_1.IconEnum.X_MARK, sx: rightPanelIconDefaultSx, dataTestId: "below-threshold-score-icon" }));
                }
            }
            break;
        case enums_1.AssignmentStateEnum.OVERDUE:
            rightPanelColor = 'error.main';
            rightPanelString = dueDateString;
            rightPanelStatus = 'Overdue';
            assignmentTitleColor = 'error.main';
            rightPanelIcon = (react_1.default.createElement(icon_1.Icon, { icon: enums_1.IconEnum.OVERDUE, sx: rightPanelIconDefaultSx, dataTestId: "overdue-icon" }));
            break;
        case enums_1.AssignmentStateEnum.STARTED:
            rightPanelString = dueDateString;
            rightPanelStatus = 'In Progress';
            rightPanelIcon = (react_1.default.createElement(icon_1.Icon, { icon: enums_1.IconEnum.CIRCLE_PLAY, size: enums_1.IconSizeEnum.XXSMALL, sx: rightPanelIconDefaultSx, dataTestId: "started-assignment-icon" }));
            rightPanelColor = 'primary.dark';
            break;
        case enums_1.AssignmentStateEnum.UPCOMING:
            subjectIconSx = __assign(__assign({}, subjectIconSx), defaultSubjectIconSxMap);
            deactivateCard = true;
            rightPanelString = dueDateString;
            rightPanelIcon = (react_1.default.createElement(icon_1.Icon, { icon: enums_1.IconEnum.LOCK, sx: rightPanelIconDefaultSx, dataTestId: "lock-icon" }));
            break;
    }
    if (deactivateCard === true) {
        subjectIconSx = __assign(__assign({}, subjectIconSx), defaultSubjectIconSxMap);
        rightPanelIcon = (react_1.default.createElement(icon_1.Icon, { icon: enums_1.IconEnum.LOCK, sx: rightPanelIconDefaultSx, dataTestId: "lock-icon" }));
    }
    var brandState = (0, react_1.useContext)(providers_1.BrandContext);
    if (!brandState) {
        brandState = (0, providers_1.getBrandState)(enums_1.BrandEnum.MONARCH);
    }
    // get the brand subject color from the brand configs
    var brandSubjectColor = brand_config_1.brandConfig[brandState.brand].subject[subject];
    var showSubjectIcon = (0, material_1.useMediaQuery)(function (theme) { return theme.breakpoints.up('sm'); });
    return (0, il_card_1.IlCard)(__assign(__assign({ clickable: clickable, onClick: onClick, sx: __assign({ minHeight: '5rem', padding: 0, border: 'none', borderTopWidth: '0.3125rem', borderTopStyle: 'solid', borderTopColor: brandSubjectColor, pb: '0.625rem' }, sx), cardActionAreaSx: {
            pb: '0.625rem',
        }, flexBoxSx: {
            minHeight: '5rem',
        }, contentFlexBoxSx: {
            display: 'flex',
            maxHeight: '2rem',
            height: '2rem',
            padding: '0.75rem',
            paddingBottom: '0.375rem',
        } }, (showSubjectIcon
        ? {
            leftSx: {
                display: 'flex',
                flex: '0 0 2rem',
                alignItems: 'start',
                maxWidth: '2rem',
                maxHeight: '2rem',
                minHeight: '2rem',
                pr: '0.75rem',
            },
            leftContent: (react_1.default.createElement(material_1.Box, { sx: { position: 'relative' } },
                react_1.default.createElement(subject_icon_1.SubjectIcon, { dataTestId: 'subject-icon', subject: subject, sx: subjectIconSx }),
                leftPanelIconOverlay)),
        }
        : {
            leftSx: {
                display: 'none',
            },
        })), { centerSx: exports.ilAssignmentDescriptionSx, centerContent: (react_1.default.createElement(material_1.Box, { sx: __assign(__assign({}, exports.ilAssignmentDescriptionSx), { gap: '0.15625rem', py: '0.125rem' }) },
            react_1.default.createElement(IlAssignmentContentDescription, { assignmentType: assignmentType }),
            react_1.default.createElement(typeography_common_1.ILH6, { sx: __assign(__assign({}, exports.truncateSx), { color: assignmentTitleColor }) }, assignmentTitle))), rightSx: {
            display: 'flex',
            flex: '0 1 7rem',
            flexDirection: 'row',
            justifyContent: 'flex-end',
            color: rightPanelColor,
        }, rightContent: (react_1.default.createElement(material_1.Box, { sx: { display: 'flex', flexDirection: 'flex-start', gap: '0.125rem' } },
            react_1.default.createElement(typeography_common_1.ILCaption, { sx: __assign({ pl: '0.25rem', fontWeight: 600, display: { xs: 'none', md: 'block' } }, exports.truncateSx) },
                rightPanelStatus && "".concat(rightPanelStatus, " | "),
                rightPanelString),
            react_1.default.createElement(typeography_common_1.ILCaption, { sx: __assign({ pl: '0.25rem', fontWeight: 600, display: { xs: 'block', md: 'none' } }, exports.truncateSx) }, rightPanelStatus !== null && rightPanelStatus !== void 0 ? rightPanelStatus : rightPanelString),
            rightPanelIcon)), showFooter: true, footerSx: exports.ilAssignmentFooterSx, footerContent: (react_1.default.createElement(typeography_common_1.ILCaption, { "data-testid": 'footer-caption', sx: __assign({ color: 'text.secondary', lineHeight: '1rem', display: 'flex', justifyContent: 'flex-start', pr: '1.125rem' }, exports.truncateSx) },
            react_1.default.createElement(material_1.Box, { sx: __assign({ p: 0, flex: '1 1 auto', display: 'block' }, exports.truncateSx) }, courseTitle),
            react_1.default.createElement(material_1.Box, { sx: __assign({ p: 0, flex: '1 1 auto', display: { xs: 'none', sm: 'block' } }, exports.truncateSx) },
                "\u00A0\u2022 ",
                unitTitle))) }));
}
exports.IlCardAssignment = IlCardAssignment;
